// @ts-nocheck
import { Game } from "../game-base";
import { TAU, len, clamp } from "../../util";

const poolGradCache = new Map();

function poisonPoolGradient(c, r) {
  const key = Math.round(r / 8);
  let g = poolGradCache.get(key);
  if (!g) {
    g = c.createRadialGradient(0, 0, r * 0.08, 0, 0, r);
    g.addColorStop(0, "rgba(74,120,32,0.38)");
    g.addColorStop(0.45, "rgba(106,138,48,0.32)");
    g.addColorStop(0.78, "rgba(200,208,64,0.22)");
    g.addColorStop(1, "rgba(26,32,16,0.04)");
    poolGradCache.set(key, g);
  }
  return g;
}

function drawPoisonPoolForming(c, pool, t) {
  const r = pool.r;
  const armTotal = 0.5;
  const prog = armTotal > 0 ? clamp(1 - pool.arm / armTotal, 0, 1) : 1;
  c.save();
  c.translate(pool.x, pool.y);
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = `rgba(200,208,64,${0.35 + 0.25 * Math.sin(t * 10)})`;
  c.lineWidth = 3;
  c.setLineDash([10, 8]);
  c.lineDashOffset = -t * 24;
  c.beginPath();
  c.arc(0, 0, r * prog, 0, TAU);
  c.stroke();
  c.setLineDash([]);
  const fill = c.createRadialGradient(0, 0, 0, 0, 0, r * prog);
  fill.addColorStop(0, `rgba(106,138,48,${0.12 + prog * 0.18})`);
  fill.addColorStop(1, "rgba(200,208,64,0)");
  c.fillStyle = fill;
  c.beginPath();
  c.arc(0, 0, r * prog, 0, TAU);
  c.fill();
  for (let i = 0; i < 5; i++) {
    const a = (i / 5) * TAU + t * 0.6;
    const cr = r * prog * (0.35 + (i % 3) * 0.12);
    c.strokeStyle = `rgba(74,40,72,${0.25 + 0.2 * prog})`;
    c.lineWidth = 2;
    c.beginPath();
    c.moveTo(Math.cos(a) * cr * 0.3, Math.sin(a) * cr * 0.3);
    c.lineTo(Math.cos(a) * cr, Math.sin(a) * cr);
    c.stroke();
  }
  c.restore();
}
Game.prototype.drawPoisonPools = function () {
  const c = this.ctx;
  const t = this.nowS;
  for (const pool of this.poisonPools || []) {
    if (pool.arm > 0) {
      drawPoisonPoolForming(c, pool, t);
      continue;
    }
    const r = pool.r;
    const pulse = 0.88 + 0.12 * Math.sin(t * 4 + pool.x * 0.01);
    c.save();
    c.translate(pool.x, pool.y);
    c.globalAlpha = pulse;
    c.globalCompositeOperation = "lighter";
    c.fillStyle = poisonPoolGradient(c, r);
    c.beginPath();
    c.arc(0, 0, r, 0, TAU);
    c.fill();
    c.globalAlpha = 1;
    c.strokeStyle = `rgba(200,208,64,${0.65 + 0.2 * Math.sin(t * 6)})`;
    c.lineWidth = 3.5;
    c.beginPath();
    c.arc(0, 0, r, 0, TAU);
    c.stroke();
    c.strokeStyle = `rgba(106,138,48,${0.35 + 0.15 * Math.sin(t * 5 + 1)})`;
    c.lineWidth = 1.5;
    c.beginPath();
    c.arc(0, 0, r * 0.92, 0, TAU);
    c.stroke();
    c.globalCompositeOperation = "source-over";
    for (let i = 0; i < 4; i++) {
      const bx = Math.sin(t * 2.2 + i * 2.1) * r * 0.32;
      const by = Math.cos(t * 1.8 + i * 1.4) * r * 0.22;
      const br = r * (0.10 + 0.05 * Math.sin(t * 3 + i));
      c.fillStyle = `rgba(200,208,64,${0.22 + 0.1 * Math.sin(t * 5 + i)})`;
      c.beginPath();
      c.arc(bx, by, br, 0, TAU);
      c.fill();
    }
    c.restore();
  }
};

Game.prototype.spawnPlagueStain = function (x, y, r) {
  // Cosmetic floor memory only — no gameplay (Plague Burst checks live pools, not stains).
  if (!this.plagueStains) this.plagueStains = [];
  this.plagueStains.push({ x, y, r, t: 0, maxLife: 18, life: 18 });
};

Game.prototype.updatePlagueStains = function (dt) {
  if (!this.plagueStains?.length) return;
  for (const st of this.plagueStains) {
    st.t += dt;
    st.life = st.maxLife - st.t;
  }
  this.plagueStains = this.plagueStains.filter(st => st.life > 0);
};

Game.prototype.drawPlagueStains = function () {
  const c = this.ctx;
  const t = this.nowS;
  for (const stain of this.plagueStains || []) {
    const fade = clamp(stain.life / stain.maxLife, 0, 1);
    if (fade <= 0) continue;
    c.save();
    c.translate(stain.x, stain.y);
    c.globalCompositeOperation = "lighter";
    c.globalAlpha = fade * 0.35;
    const g = c.createRadialGradient(0, 0, stain.r * 0.1, 0, 0, stain.r);
    g.addColorStop(0, "rgba(106,138,48,0.4)");
    g.addColorStop(0.7, "rgba(74,40,72,0.25)");
    g.addColorStop(1, "rgba(26,32,16,0)");
    c.fillStyle = g;
    c.beginPath();
    c.arc(0, 0, stain.r, 0, TAU);
    c.fill();
    c.globalAlpha = fade * 0.5;
    c.strokeStyle = "rgba(200,208,64,0.3)";
    c.lineWidth = 1.5;
    c.beginPath();
    c.arc(0, 0, stain.r * (0.85 + 0.05 * Math.sin(t * 2 + stain.x)), 0, TAU);
    c.stroke();
    c.restore();
  }
};

Game.prototype.drawContagionOverlay = function (c, p) {
  if (!p.contagion) return;
  const t = this.nowS;
  const br = p.radius + 10;
  const pulse = 0.55 + 0.35 * Math.sin(t * 9);
  c.save();
  c.globalCompositeOperation = "lighter";
  const g = c.createRadialGradient(0, -p.radius * 0.2, br * 0.1, 0, -p.radius * 0.2, br * 0.55);
  g.addColorStop(0, `rgba(200,208,64,${0.55 * pulse})`);
  g.addColorStop(0.6, `rgba(106,138,48,${0.35 * pulse})`);
  g.addColorStop(1, "rgba(74,40,72,0)");
  c.fillStyle = g;
  c.beginPath();
  c.arc(0, -p.radius * 0.2, br * 0.55, 0, TAU);
  c.fill();
  c.strokeStyle = `rgba(200,208,64,${0.75 * pulse})`;
  c.lineWidth = 2.5;
  c.setLineDash([6, 5]);
  c.lineDashOffset = -t * 18;
  c.beginPath();
  c.arc(0, -p.radius * 0.2, br * 0.42, 0, TAU);
  c.stroke();
  c.setLineDash([]);
  c.font = `${Math.round(Math.max(14, 18 / this.scale))}px sans-serif`;
  c.textAlign = "center";
  c.textBaseline = "middle";
  c.fillText("🦠", 0, -p.radius * 0.2);
  c.restore();
};

Game.prototype.drawContagionTether = function () {
  const local = this.human();
  if (!local || !local.contagion || !local.alive) return;
  let nearest = null;
  let best = Infinity;
  for (const p of this.players) {
    if (p === local || !p.alive || p.falling || p.contagion) continue;
    const d = len(p.x - local.x, p.y - local.y);
    if (d < best) { best = d; nearest = p; }
  }
  if (!nearest || best > 280) return;
  const c = this.ctx;
  const t = this.nowS;
  const pulse = 0.45 + 0.35 * Math.sin(t * 10);
  c.save();
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = `rgba(200,208,64,${pulse})`;
  c.lineWidth = 3;
  c.setLineDash([8, 6]);
  c.lineDashOffset = -t * 30;
  c.beginPath();
  c.moveTo(local.x, local.y);
  c.lineTo(nearest.x, nearest.y);
  c.stroke();
  c.setLineDash([]);
  c.restore();
};
